
import Utils from '@utils/utils';
import { useImperativeHandle, forwardRef, useContext, useState, useRef, useMemo, useEffect } from "react"
import { AppContext } from "@utils/AppContext"
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss'
import { Button, Input, message, Spin } from 'antd';
import { CheckCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import API, { commonApiInvoker } from "@api/api"
import eventBus from "@utils/eventBus"
import Iconfont from '@utils/Iconfont';


const CompleteSeiviceInfoModal = forwardRef((props, ref) => {
    const {
        globalUser,
    } = useContext(AppContext)

    const [open, setOpen] = useState(false)
    const [mobile, setMobile] = useState()
    const [company, setCompany] = useState()
    const [isMobileError, setIsMobileError] = useState(false)
    const [verifyCode, setVerifyCode] = useState()
    const [waitCode, setWaitCode] = useState(false)
    const [countdown, setCountdown] = useState(60)
    const countdownRef = useRef(60)
    const [intervalId, setIntervalId] = useState()
    const [loading, setLoading] = useState(false)
    const [callback, setCallback] = useState(null)


    useImperativeHandle(ref, () => ({
        handleClick
    }))

    useEffect(() => {
        return () => {
            intervalId && clearInterval(intervalId)
        }
    }, [])

    const handleClick = (callback) => {
        setCallback(() => callback);
        const status = Utils.checkLoginStatus(() => loginAfter(callback))
        if (status) loginAfter(callback)
    }

    const loginAfter = (callback) => {
        API.userInfo({}).then((res) => {
            if (res.code == 0) {
                setCompany(res.data?.company)
                if (!res.data?.mobile || !res.data?.company || !res.data?.thirdPartyLoginChannel?.includes('wechat')) {
                    setOpen(true)
                } else {
                    callback()
                }
            }
        })
    }

    const onOk = () => {
        commonApiInvoker(API.bindMobileOrCompany({
            mobile: mobile,
            verifyCode: verifyCode,
            platform: 'psai',
            companyName: company?.trim(),
        }), setLoading, false).then(res => {
            callback()
            eventBus.emit('updatePower')
            eventBus.emit('updateUserInfo')
            eventBus.emit('getUserOrgInfo')
            setOpen(false)
        })
    }

    const mobileBlur = () => {
        setIsMobileError(!Utils.validateContact(mobile))
    }

    const codeClick = () => {
        mobileBlur()
        if (!Utils.validateContact(mobile)) return
        if (!waitCode) {
            setWaitCode(true)
            API.userSendCode({
                mobile: mobile
            }).then((res) => {
                if (res.code == 0) {
                    message.success('发送成功！')
                    let id = setInterval(() => {
                        countdownRef.current -= 1
                        setCountdown(countdownRef.current)
                        if (countdownRef.current === 0) {
                            clearInterval(id)
                            setWaitCode(false)
                            countdownRef.current = 60
                        }
                    }, 1000)
                    setIntervalId(id)
                } else {
                    setWaitCode(false)
                    message.error(res.message)
                }
            })
        }
    }

    // 绑定微信
    const timeoutRef = useRef(null);
    const timeoutRef2 = useRef(null);
    const [wechatUrl, setWechatUrl] = useState()
    const [sceneStr, setSceneStr] = useState()
    const [spanLoading, setSpanLoading] = useState(false)
    const [bindsuccessed, setBindsuccessed] = useState(false)
    const wechatQrcode = () => {
        setSpanLoading(true)
        API.wechatQrcode().then((res) => {
            setSpanLoading(false)
            if (res.code == 0) {
                setWechatUrl(res.data.url)
                setSceneStr(res.data.sceneStr)
            } else {
                message.error(res.message)
            }
        })
    }

    useEffect(() => {
        setSceneStr()
        clearInterval(timeoutRef.current)
        clearInterval(timeoutRef2.current)
        if (open && !globalUser?.thirdPartyLoginChannel?.includes('wechat')) {
            wechatQrcode()
            timeoutRef.current = setInterval(() => {
                wechatQrcode()
            }, 120000)
        }
    }, [open, globalUser?.thirdPartyLoginChannel])

    const bindStatus = () => {
        API.bindStatus({
            sceneStr: sceneStr,
        }).then((res) => {
            if (res.code == 0) {
                clearInterval(timeoutRef.current)
                clearInterval(timeoutRef2.current)

                setTimeout(() => {
                    message.success('绑定成功！')
                    setBindsuccessed(true)
                    // eventBus.emit('updateUserInfo')
                }, 500)
            } else if (res.code == -5036) {
                timeoutRef2.current = setTimeout(() => {
                    bindStatus()
                }, 1000)
            } else {
                clearInterval(timeoutRef.current)
                clearInterval(timeoutRef2.current)
                message.warning(res.message == '二维码已过期或不存在' ? null : res.message)
            }
        })
    }

    useEffect(() => {
        if (!sceneStr || !open) return
        bindStatus()
    }, [sceneStr])

    const isTrueConfirm = useMemo(() => {
        if (!globalUser?.mobile && !globalUser?.company) {
            return mobile && verifyCode && company?.trim()
        } else if (!globalUser?.thirdPartyLoginChannel?.includes('wechat') && !globalUser?.company) {
            return bindsuccessed && company?.trim()
        } else {
            return company?.trim()
        }
    }, [bindsuccessed, mobile, verifyCode, company])

    return (
        <>
            <PSAIModal
                title='请补全信息'
                maxWidth={400}
                okText={'确定'}
                open={open}
                maskClosable={false}
                okButtonProps={{ disabled: !isTrueConfirm, loading: loading }}
                onCancel={() => setOpen(false)}
                onOk={onOk}
            >
                <div className={styles.mobileModal_body}>
                    <div className={styles.mobileModal_form}>
                        {
                            !globalUser?.mobile && <>
                                <div className={styles.mobileModal_mobile}>
                                    <Input
                                        id='mobile-new'
                                        className={styles.mobileModal_new_input}
                                        size='large'
                                        value={mobile}
                                        placeholder="请输入手机号"
                                        onBlur={mobileBlur}
                                        onChange={(e) => setMobile(e.target.value)}
                                        prefix={<Iconfont className={styles.Icon} type="icon-phoneOutlined" />}
                                        allowClear={{
                                            clearIcon: <Iconfont className={styles.Icon2} type="icon-backspaceOutlined" />
                                        }}
                                    />
                                </div>
                                <div className={styles.mobileModal_code}>
                                    <Input
                                        id='mobile-code'
                                        size='large'
                                        maxLength={6}
                                        value={verifyCode}
                                        placeholder="请输入验证码"
                                        onChange={(e) => setVerifyCode(e.target.value)}
                                        prefix={<Iconfont className={styles.Icon} type="icon-codeOutlined" />}
                                        suffix={
                                            <Button size='small' onClick={codeClick}>{waitCode ? `${countdown}秒` : '发送验证码'}</Button>
                                        }
                                    />
                                </div>
                            </>
                        }
                        {
                            <div className={styles.mobileModal_mobile} style={{ marginBottom: 0 }}>
                                <Input
                                    id='mobile-company'
                                    className={styles.mobileModal_new_input}
                                    size='large'
                                    value={company}
                                    placeholder="请填写您的公司名称（必填）"
                                    onChange={(e) => setCompany(e.target.value)}
                                    prefix={<Iconfont className={styles.Icon} type="icon-companyOutlined" />}
                                    disabled={globalUser?.company}
                                    allowClear={{
                                        clearIcon: <Iconfont className={styles.Icon2} type="icon-backspaceOutlined" />
                                    }}
                                />
                            </div>
                        }
                        {
                            !globalUser?.thirdPartyLoginChannel?.includes('wechat') &&
                            <div className={styles.mobileModal_mobile}>
                                <div className={styles.bindWechatModal_body}>
                                    {
                                        <div className={styles.bindWechatModal_img}>
                                            <div className={styles.bindWechatModal_img_}>
                                                {
                                                    bindsuccessed ? <>
                                                        <CheckCircleFilled style={{ color: '#34C759', fontSize: '14px' }} />
                                                        <p>扫码成功</p>
                                                    </> : <img src={wechatUrl} alt="" />
                                                }
                                            </div>

                                        </div>
                                    }
                                    <div className={styles.bindWechatModal_text}>
                                        <>
                                            <p>确认先填写公司信息</p>
                                            <p>然后使用微信扫描左侧二维码</p>
                                            <p>关注公众号完成信息补充</p>
                                        </>
                                    </div>
                                </div>
                            </div>
                        }
                        <p className={styles.err_text} style={{ display: isMobileError ? 'flex' : 'none' }}><ExclamationCircleOutlined /> 您输入的手机号错误</p>
                    </div>
                </div>
            </PSAIModal>
        </>
    )
})

export default CompleteSeiviceInfoModal